import { Helmet } from 'react-helmet-async'

interface SeoHelmetProps {
  title: string
  description: string
  image: string
  url: string
  pageType: 'website' | 'article'
}

const BASE_URL =
  process.env.REACT_APP_BASE_URL || 'https://greenmango.net'

function absoluteUrl(path: string): string {
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  return `${BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`
}

export function SeoHelmet({ title, description, image, url, pageType }: SeoHelmetProps) {
  const absImage = absoluteUrl(image)
  const absUrl = absoluteUrl(url)
  const schemaType = pageType === 'article' ? 'Article' : 'WebPage'

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': schemaType,
    headline: title,
    description,
    image: absImage,
    url: absUrl,
  }

  return (
    <Helmet>
      <meta name="robots" content={process.env.REACT_APP_ALLOW_INDEXING === 'true' ? 'index,follow' : 'noindex,nofollow'} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:url" content={absUrl} />
      <meta property="og:type" content={pageType} />
      <meta property="og:site_name" content="greenmango" />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absImage} />
      <link rel="canonical" href={absUrl} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  )
}
